module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('sidebar.reportedIssues'),
      "alternativeRoute": "issues/reported-issues"
    }
  })], 1), _vm._v(" "), _c('datatable', {
    attrs: {
      "url": _vm.pagedIssuesUrl,
      "columns": _vm.tColumns,
      "options": _vm.tOptions,
      "reportsUrl": _vm.issuesReportsUrl
    },
    scopedSlots: _vm._u([{
      key: "creationDate",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.creationDate)))])]
      }
    }, {
      key: "closingDate",
      fn: function(props) {
        return [(props.row.closingDate) ? _c('span', [_vm._v(_vm._s(_vm.formatDate(props.row.closingDate)))]) : _c('span', [_vm._v("-")])]
      }
    }, {
      key: "status",
      fn: function(props) {
        return [(props.row.status === _vm.IssueStatus.ACTIVE) ? _c('button', {
          staticClass: "btn btn-sm btn-info"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.CANCELLED) ? _c('button', {
          staticClass: "btn btn-sm btn-danger"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.RESOLVED) ? _c('button', {
          staticClass: "btn btn-sm btn-success"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : (props.row.status === _vm.IssueStatus.UNRESOLVED) ? _c('button', {
          staticClass: "btn btn-sm btn-danger"
        }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueStatus.' + props.row.status)))]) : _vm._e()]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f70bb0cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f70bb0cc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/issues/reported-issues.html
// module id = 812
// module chunks = 1